(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./packages/@logrocket/console/src/index.js":
/*!**************************************************!*\
  !*** ./packages/@logrocket/console/src/index.js ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _registerConsole = _interopRequireDefault(__webpack_require__(/*! ./registerConsole */ "./packages/@logrocket/console/src/registerConsole.js"));
var _default = _registerConsole.default;
exports["default"] = _default;

/***/ }),

/***/ "./packages/@logrocket/console/src/registerConsole.js":
/*!************************************************************!*\
  !*** ./packages/@logrocket/console/src/registerConsole.js ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = registerConsole;
var _typeof2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));
var _enhanceFunc = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/enhanceFunc */ "./packages/@logrocket/utils/src/enhanceFunc.ts"));
var _exceptions = __webpack_require__(/*! @logrocket/exceptions */ "./packages/@logrocket/exceptions/src/index.js");
// eslint-disable-line no-restricted-imports

function registerConsole(logger) {
  var unsubFunctions = [];
  var methods = ['log', 'warn', 'info', 'error', 'debug'];
  methods.forEach(function (method) {
    unsubFunctions.push((0, _enhanceFunc.default)(console, method, function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      logger.addEvent('lr.core.LogEvent', function () {
        var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var isEnabled = consoleOptions.isEnabled;
        if ((0, _typeof2.default)(isEnabled) === 'object' && isEnabled[method] === false || isEnabled === false) {
          return null;
        }
        if (method === 'error' && consoleOptions.shouldAggregateConsoleErrors) {
          // some customers have loggers that add the log level as the first arg
          if (!!args && args.length >= 2 && args[0] === 'ERROR') {
            var secondArg = '';
            try {
              secondArg = " ".concat(args[1]);
            } catch (_unused) {} // eslint-disable-line no-empty
            _exceptions.Capture.captureMessage(logger, "".concat(args[0]).concat(secondArg), args, {}, true);
          } else {
            _exceptions.Capture.captureMessage(logger, args[0], args, {}, true);
          }
        }
        return {
          logLevel: method.toUpperCase(),
          args: args
        };
      });
    }));
  });
  return function () {
    unsubFunctions.forEach(function (unsubFunction) {
      return unsubFunction();
    });
  };
}

/***/ }),

/***/ "./packages/@logrocket/exceptions/src/Capture.js":
/*!*******************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/Capture.js ***!
  \*******************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.captureMessage = captureMessage;
exports.captureException = captureException;
var _scrubException = __webpack_require__(/*! @logrocket/utils/src/scrubException */ "./packages/@logrocket/utils/src/scrubException.ts");
var _TraceKit = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/TraceKit */ "./packages/@logrocket/utils/src/TraceKit.js"));
var _stackTraceFromError = _interopRequireDefault(__webpack_require__(/*! ./stackTraceFromError */ "./packages/@logrocket/exceptions/src/stackTraceFromError.js"));
// eslint-disable-line no-restricted-imports
// eslint-disable-line no-restricted-imports

function captureMessage(logger, message, messageArgs) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var isConsole = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var data = {
    exceptionType: isConsole ? 'CONSOLE' : 'MESSAGE',
    message: message,
    messageArgs: messageArgs,
    browserHref: window.location ? window.location.href : ''
  };
  (0, _scrubException.scrubException)(data, options);
  logger.addEvent('lr.core.Exception', function () {
    return data;
  });
}
function captureException(logger, exception) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var preppedTrace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var exceptionType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'WINDOW';
  var trace = preppedTrace || _TraceKit.default.computeStackTrace(exception);
  var data = {
    exceptionType: exceptionType,
    errorType: trace.name,
    message: trace.message,
    browserHref: window.location ? window.location.href : ''
  };
  (0, _scrubException.scrubException)(data, options);
  var addEventOptions = {
    _stackTrace: (0, _stackTraceFromError.default)(trace)
  };
  logger.addEvent('lr.core.Exception', function () {
    return data;
  }, addEventOptions);
}

/***/ }),

/***/ "./packages/@logrocket/exceptions/src/index.js":
/*!*****************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/index.js ***!
  \*****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "registerExceptions", ({
  enumerable: true,
  get: function get() {
    return _registerExceptions.default;
  }
}));
exports.Capture = void 0;
var _registerExceptions = _interopRequireDefault(__webpack_require__(/*! ./registerExceptions */ "./packages/@logrocket/exceptions/src/registerExceptions.js"));
var Capture = _interopRequireWildcard(__webpack_require__(/*! ./Capture */ "./packages/@logrocket/exceptions/src/Capture.js"));
exports.Capture = Capture;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***/ }),

/***/ "./packages/@logrocket/exceptions/src/raven/raven.js":
/*!***********************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/raven/raven.js ***!
  \***********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js"));
var _TraceKit = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/TraceKit */ "./packages/@logrocket/utils/src/TraceKit.js"));
/* eslint-disable */

/*
Some contents of this file were originaly from raven-js, BSD-2 Clause

Copyright (c) 2018 Sentry (https://sentry.io) and individual contributors.
All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
* Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

var objectPrototype = Object.prototype;
function isUndefined(what) {
  return what === void 0;
}
function isFunction(what) {
  return typeof what === 'function';
}
function each(obj, callback) {
  var i, j;
  if (isUndefined(obj.length)) {
    for (i in obj) {
      if (hasKey(obj, i)) {
        callback.call(null, i, obj[i]);
      }
    }
  } else {
    j = obj.length;
    if (j) {
      for (i = 0; i < j; i++) {
        callback.call(null, i, obj[i]);
      }
    }
  }
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
  return objectPrototype.hasOwnProperty.call(object, key);
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
  var orig = obj[name];
  obj[name] = replacement(orig);
  if (track) {
    track.push([obj, name, orig]);
  }
}
var _window = typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};
var _document = _window.document;
var Handler = /*#__PURE__*/function () {
  function Handler(_ref) {
    var captureException = _ref.captureException;
    (0, _classCallCheck2.default)(this, Handler);
    this._errorHandler = this._errorHandler.bind(this);
    this._ignoreOnError = 0;
    this._wrappedBuiltIns = [];
    this.captureException = captureException;
    _TraceKit.default.report.subscribe(this._errorHandler);
    this._instrumentTryCatch();
  }
  (0, _createClass2.default)(Handler, [{
    key: "uninstall",
    value: function uninstall() {
      _TraceKit.default.report.unsubscribe(this._errorHandler);

      // restore any wrapped builtins
      var builtin;
      while (this._wrappedBuiltIns.length) {
        builtin = this._wrappedBuiltIns.shift();
        var obj = builtin[0],
          name = builtin[1],
          orig = builtin[2];
        obj[name] = orig;
      }
    }
  }, {
    key: "_errorHandler",
    value: function _errorHandler(report) {
      if (!this._ignoreOnError) {
        this.captureException(report);
      }
    }
  }, {
    key: "_ignoreNextOnError",
    value: function _ignoreNextOnError() {
      var _this = this;
      this._ignoreOnError += 1;
      setTimeout(function () {
        // onerror should trigger before setTimeout
        _this._ignoreOnError -= 1;
      });
    }

    /*
     * Wrap code within a context so Handler can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
  }, {
    key: "context",
    value: function context(options, func, args) {
      if (isFunction(options)) {
        args = func || [];
        func = options;
        options = undefined;
      }
      return this.wrap(options, func).apply(this, args);
    }
  }, {
    key: "wrap",
    value:
    /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} func A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
    function wrap(options, func, _before) {
      var self = this;
      // 1 argument has been passed, and it's not a function
      // so just return it
      if (isUndefined(func) && !isFunction(options)) {
        return options;
      }

      // options is optional
      if (isFunction(options)) {
        func = options;
        options = undefined;
      }

      // At this point, we've passed along 2 arguments, and the second one
      // is not a function either, so we'll just return the second argument.
      if (!isFunction(func)) {
        return func;
      }

      // We don't wanna wrap it twice!
      try {
        if (func.__lr__) {
          return func;
        }

        // If this has already been wrapped in the past, return that
        if (func.__lr_wrapper__) {
          return func.__lr_wrapper__;
        }

        // If func is not extensible, return the function as-is to prevent TypeErrors
        // when trying to add new props & to assure immutable funcs aren't changed
        if (!Object.isExtensible(func)) {
          return func;
        }
      } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see lr-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return func;
      }
      function wrapped() {
        var args = [],
          i = arguments.length,
          deep = !options || options && options.deep !== false;
        if (_before && isFunction(_before)) {
          _before.apply(this, arguments);
        }

        // Recursively wrap all of a function's arguments that are
        // functions themselves.
        while (i--) {
          args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
        }
        try {
          // Attempt to invoke user-land function. This is part of the LogRocket SDK.
          // If you're seeing this frame in a stack trace, it means that LogRocket caught
          // an unhandled error thrown by your application code, reported it, then bubbled
          // it up. This is expected behavior and is not a bug with LogRocket.
          return func.apply(this, args);
        } catch (e) {
          self._ignoreNextOnError();
          self.captureException(_TraceKit.default.computeStackTrace(e), options);
          throw e;
        }
      }

      // copy over properties of the old function
      for (var property in func) {
        if (hasKey(func, property)) {
          wrapped[property] = func[property];
        }
      }
      wrapped.prototype = func.prototype;
      func.__lr_wrapper__ = wrapped;
      // Signal that this function has been wrapped already
      // for both debugging and to prevent it to being wrapped twice
      wrapped.__lr__ = true;
      wrapped.__inner__ = func;
      return wrapped;
    }
  }, {
    key: "_instrumentTryCatch",
    value:
    /**
     * Install any queued plugins
     */
    function _instrumentTryCatch() {
      var self = this;
      var wrappedBuiltIns = self._wrappedBuiltIns;
      function wrapTimeFn(orig) {
        return function (fn, t) {
          // preserve arity
          // Make a copy of the arguments to prevent deoptimization
          // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
          var args = new Array(arguments.length);
          for (var i = 0; i < args.length; ++i) {
            args[i] = arguments[i];
          }
          var originalCallback = args[0];
          if (isFunction(originalCallback)) {
            args[0] = self.wrap(originalCallback);
          }

          // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
          // also supports only two arguments and doesn't care what this is, so we
          // can just call the original function directly.
          if (orig.apply) {
            return orig.apply(this, args);
          } else {
            return orig(args[0], args[1]);
          }
        };
      }
      function wrapEventTarget(global) {
        var proto = _window[global] && _window[global].prototype;
        if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
          fill(proto, 'addEventListener', function (orig) {
            return function (evtName, fn, capture, secure) {
              // preserve arity
              try {
                if (fn && fn.handleEvent) {
                  fn.handleEvent = self.wrap(fn.handleEvent);
                }
              } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
              }

              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
              // so that we don't have more than one wrapper function
              var before;
              return orig.call(this, evtName, self.wrap(fn, undefined, before), capture, secure);
            };
          }, wrappedBuiltIns);
          fill(proto, 'removeEventListener', function (orig) {
            return function (evt, fn, capture, secure) {
              /**
               * There are 3 scenararios to consider when removing an event listener
               *
               * 1. 'addEventListener' was called when the LR SDK was uninitialized.
               * In this case, the event handler has not been wrapped, so this behaves 
               * as a passthrough and just removes the original handler.
               *
               * 2. 'addEventListener' was called while the LR SDK was initialized, which means
               * our wrapped 'addEventListener' was called. In this case, the tracked event handler
               * is also wrapped, so we need to remove that wrapped version of the handler.
               *
               * 3. 'addEventListener' was called both before and after the LR SDK was initialized
               * for the same event handler. In this case, we have to remove both of them.
               * If we'd remove only the wrapped one, the initial handler would stick around forever.
               */
              try {
                var wrappedFn = fn === null || fn === void 0 ? void 0 : fn.__lr_wrapper__;
                if (wrappedFn) {
                  orig.call(this, evt, wrappedFn, capture, secure);
                }
              } catch (e) {
                // ignore, accessing __lr_wrapper__ will throw in some Selenium environments
              }
              return orig.call(this, evt, fn, capture, secure);
            };
          },
          // undefined is provided here to skip tracking for uninstall.
          // Once our removeEventListener is installed, it can't be uninstalled.
          // We always need to support removing logrocket wrapped event handlers (event
          // handlers added when logrocket was installed) even after SDK shutdown.
          undefined);
        }
      }
      fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
      fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
      if (_window.requestAnimationFrame) {
        fill(_window, 'requestAnimationFrame', function (orig) {
          return function (cb) {
            return orig(self.wrap(cb));
          };
        }, wrappedBuiltIns);
      }

      // event targets borrowed from bugsnag-js:
      // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
      var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
      for (var i = 0; i < eventTargets.length; i++) {
        wrapEventTarget(eventTargets[i]);
      }
      var $ = _window.jQuery || _window.$;
      if ($ && $.fn && $.fn.ready) {
        fill($.fn, 'ready', function (orig) {
          return function (fn) {
            return orig.call(this, self.wrap(fn));
          };
        }, wrappedBuiltIns);
      }
    }
  }]);
  return Handler;
}();
exports["default"] = Handler;
;

/***/ }),

/***/ "./packages/@logrocket/exceptions/src/registerExceptions.js":
/*!******************************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/registerExceptions.js ***!
  \******************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = registerCore;
var _raven = _interopRequireDefault(__webpack_require__(/*! ./raven/raven */ "./packages/@logrocket/exceptions/src/raven/raven.js"));
var Capture = _interopRequireWildcard(__webpack_require__(/*! ./Capture */ "./packages/@logrocket/exceptions/src/Capture.js"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function registerCore(logger) {
  var raven = new _raven.default({
    captureException: function captureException(errorReport) {
      Capture.captureException(logger, null, null, errorReport);
    }
  });
  var rejectionHandler = function rejectionHandler(evt) {
    // http://2ality.com/2016/04/unhandled-rejections.html
    if (evt.reason instanceof Error) {
      Capture.captureException(logger, evt.reason, null, null, 'UNHANDLED_REJECTION');
    } else {
      logger.addEvent('lr.core.Exception', function () {
        return {
          exceptionType: 'UNHANDLED_REJECTION',
          message: evt.reason || 'Unhandled Promise rejection'
        };
      });
    }
  };
  window.addEventListener('unhandledrejection', rejectionHandler);
  return function () {
    window.removeEventListener('unhandledrejection', rejectionHandler);
    raven.uninstall();
  };
}

/***/ }),

/***/ "./packages/@logrocket/exceptions/src/stackTraceFromError.js":
/*!*******************************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/stackTraceFromError.js ***!
  \*******************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = stackTraceFromError;
function stackTraceFromError(errorReport) {
  function makeNotNull(val) {
    return val === null ? undefined : val;
  }
  return errorReport.stack ? errorReport.stack.map(function (frame) {
    return {
      lineNumber: makeNotNull(frame.line),
      columnNumber: makeNotNull(frame.column),
      fileName: makeNotNull(frame.url),
      functionName: makeNotNull(frame.func)
    };
  }) : undefined;
}

/***/ }),

/***/ "./packages/@logrocket/network/src/fetchIntercept.js":
/*!***********************************************************!*\
  !*** ./packages/@logrocket/network/src/fetchIntercept.js ***!
  \***********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _registerXHR = __webpack_require__(/*! ./registerXHR */ "./packages/@logrocket/network/src/registerXHR.js");
var interceptors = [];
function makeInterceptor(fetch, fetchId) {
  var reversedInterceptors = interceptors.reduce(function (array, interceptor) {
    return [interceptor].concat(array);
  }, []);
  // if a browser supports fetch, it supports promise
  // eslint-disable-next-line compat/compat
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  var promise = Promise.resolve(args);

  // Register request interceptors
  reversedInterceptors.forEach(function (_ref) {
    var request = _ref.request,
      requestError = _ref.requestError;
    if (request || requestError) {
      promise = promise.then(function (args) {
        return request.apply(void 0, [fetchId].concat((0, _toConsumableArray2.default)(args)));
      }, function (args) {
        return requestError.apply(void 0, [fetchId].concat((0, _toConsumableArray2.default)(args)));
      });
    }
  });
  promise = promise.then(function (args) {
    (0, _registerXHR.setActive)(false);
    var res;
    var err;
    try {
      res = fetch.apply(void 0, (0, _toConsumableArray2.default)(args));
    } catch (_err) {
      err = _err;
    }
    (0, _registerXHR.setActive)(true);
    if (err) {
      throw err;
    }
    return res;
  });
  reversedInterceptors.forEach(function (_ref2) {
    var response = _ref2.response,
      responseError = _ref2.responseError;
    if (response || responseError) {
      promise = promise.then(function (res) {
        return response(fetchId, res);
      }, function (err) {
        return responseError && responseError(fetchId, err);
      });
    }
  });
  return promise;
}
function attach(env) {
  if (!env.fetch || !env.Promise) {
    // Make sure fetch is available in the given environment. If it's not, then
    // default to using XHR intercept.
    return;
  }
  var isPolyfill = env.fetch.polyfill;

  // eslint-disable-next-line no-param-reassign
  env.fetch = function (fetch) {
    var fetchId = 0;
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return makeInterceptor.apply(void 0, [fetch, fetchId++].concat(args));
    };
  }(env.fetch);

  // Forward the polyfill properly from fetch (set by github/whatwg-fetch).
  if (isPolyfill) {
    // eslint-disable-next-line no-param-reassign
    env.fetch.polyfill = isPolyfill;
  }
}

// TODO: React Native
//   attach(global);

var didAttach = false;
var _default = {
  register: function register(interceptor) {
    if (!didAttach) {
      didAttach = true;
      attach(window);
    }
    interceptors.push(interceptor);
    return function () {
      var index = interceptors.indexOf(interceptor);
      if (index >= 0) {
        interceptors.splice(index, 1);
      }
    };
  },
  clear: function clear() {
    interceptors = [];
  }
};
exports["default"] = _default;

/***/ }),

/***/ "./packages/@logrocket/network/src/index.js":
/*!**************************************************!*\
  !*** ./packages/@logrocket/network/src/index.js ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = registerNetwork;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
var _typeof2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));
var _registerFetch = _interopRequireDefault(__webpack_require__(/*! ./registerFetch */ "./packages/@logrocket/network/src/registerFetch.js"));
var _registerIonic = __webpack_require__(/*! ./registerIonic */ "./packages/@logrocket/network/src/registerIonic.ts");
var _registerNetworkInformation = _interopRequireDefault(__webpack_require__(/*! ./registerNetworkInformation */ "./packages/@logrocket/network/src/registerNetworkInformation.js"));
var _registerXHR = _interopRequireDefault(__webpack_require__(/*! ./registerXHR */ "./packages/@logrocket/network/src/registerXHR.js"));
var _mapValues = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/mapValues */ "./packages/@logrocket/utils/src/mapValues.js"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// eslint-disable-line no-restricted-imports

function registerNetwork(logger) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    isReactNative: false,
    isDisabled: false
  };
  if ((config === null || config === void 0 ? void 0 : config.isDisabled) === true) {
    return function () {};
  }
  var isReactNative = config.isReactNative,
    shouldAugmentNPS = config.shouldAugmentNPS,
    shouldParseXHRBlob = config.shouldParseXHRBlob;
  var ignoredNetwork = {};

  // truncate if > 4MB in size
  var truncate = function truncate(data) {
    var limit = 1024 * 1000 * 4;
    var str = data;
    if ((0, _typeof2.default)(data) === 'object' && data != null) {
      var proto = Object.getPrototypeOf(data);
      if (proto === Object.prototype || proto === null) {
        // plain object - jsonify for the size check
        str = JSON.stringify(data);
      }
    }
    if (str && str.length && str.length > limit && typeof str === 'string') {
      var beginning = str.substring(0, 1000);
      return "".concat(beginning, " ... LogRocket truncating to first 1000 characters.\n      Keep data under 4MB to prevent truncation. https://docs.logrocket.com/reference/network");
    }
    return data;
  };
  var addRequest = function addRequest(reqId, request) {
    var method = request.method;
    logger.addEvent('lr.network.RequestEvent', function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$isEnabled = _ref.isEnabled,
        isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
        _ref$requestSanitizer = _ref.requestSanitizer,
        requestSanitizer = _ref$requestSanitizer === void 0 ? function (f) {
          return f;
        } : _ref$requestSanitizer;
      if (!isEnabled) {
        return null;
      }
      var sanitized = null;
      try {
        // only try catch user defined functions
        sanitized = requestSanitizer(_objectSpread(_objectSpread({}, request), {}, {
          reqId: reqId
        }));
      } catch (err) {
        console.error(err);
      }
      if (sanitized) {
        var url = sanitized.url;
        if (typeof document !== 'undefined' && typeof document.createElement === 'function') {
          // Writing and then reading from an a tag turns a relative
          // url into an absolute one.
          var a = document.createElement('a');
          a.href = sanitized.url;
          url = a.href;
        }
        return {
          reqId: reqId,
          // default
          url: url,
          // sanitized
          headers: (0, _mapValues.default)(sanitized.headers, function (headerValue) {
            // sanitized
            return "".concat(headerValue);
          }),
          body: truncate(sanitized.body),
          // sanitized
          method: method,
          // default
          referrer: sanitized.referrer || undefined,
          // sanitized
          mode: sanitized.mode || undefined,
          // sanitized
          credentials: sanitized.credentials || undefined // sanitized
        };
      }

      ignoredNetwork[reqId] = true;
      return null;
    });
  };
  var addResponse = function addResponse(reqId, response) {
    var method = response.method,
      status = response.status,
      responseType = response.responseType;
    logger.addEvent('lr.network.ResponseEvent', function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$isEnabled = _ref2.isEnabled,
        isEnabled = _ref2$isEnabled === void 0 ? true : _ref2$isEnabled,
        _ref2$responseSanitiz = _ref2.responseSanitizer,
        responseSanitizer = _ref2$responseSanitiz === void 0 ? function (f) {
          return f;
        } : _ref2$responseSanitiz;
      if (!isEnabled) {
        return null;
      } else if (ignoredNetwork[reqId]) {
        delete ignoredNetwork[reqId];
        return null;
      }
      var sanitized = null;
      try {
        // only try catch user defined functions
        sanitized = responseSanitizer(_objectSpread(_objectSpread({}, response), {}, {
          reqId: reqId
        }));
      } catch (err) {
        console.error(err);
        // fall through to redacted log
      }

      if (sanitized) {
        return {
          reqId: reqId,
          // default
          responseType: responseType,
          status: sanitized.status,
          // sanitized
          headers: (0, _mapValues.default)(sanitized.headers, function (headerValue) {
            // sanitized
            return "".concat(headerValue);
          }),
          body: truncate(sanitized.body),
          // sanitized
          method: method // default
        };
      }

      return {
        reqId: reqId,
        // default
        responseType: responseType,
        status: status,
        // default
        headers: {},
        // redacted
        body: null,
        // redacted
        method: method // default
      };
    });
  };

  var isIgnored = function isIgnored(reqId) {
    return logger.isDisabled || ignoredNetwork[reqId] === true;
  };
  var unsubFetch = (0, _registerFetch.default)({
    addRequest: addRequest,
    addResponse: addResponse,
    isIgnored: isIgnored
  });
  var unsubXHR = (0, _registerXHR.default)({
    addRequest: addRequest,
    addResponse: addResponse,
    isIgnored: isIgnored,
    logger: logger,
    shouldAugmentNPS: shouldAugmentNPS,
    shouldParseXHRBlob: shouldParseXHRBlob
  });
  var unsubIonic = (0, _registerIonic.registerIonic)({
    addRequest: addRequest,
    addResponse: addResponse,
    isIgnored: isIgnored
  });
  var unsubNetworkInformation = isReactNative ? function () {} : (0, _registerNetworkInformation.default)(logger);
  return function () {
    unsubNetworkInformation();
    unsubFetch();
    unsubXHR();
    unsubIonic();
  };
}

/***/ }),

/***/ "./packages/@logrocket/network/src/registerFetch.js":
/*!**********************************************************!*\
  !*** ./packages/@logrocket/network/src/registerFetch.js ***!
  \**********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = registerFetch;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
var _mapValues = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/mapValues */ "./packages/@logrocket/utils/src/mapValues.js"));
var _fetchIntercept = _interopRequireDefault(__webpack_require__(/*! ./fetchIntercept */ "./packages/@logrocket/network/src/fetchIntercept.js"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function makeObjectFromHeaders(headers) {
  // If using real fetch, we must stringify the Headers object.
  if (headers == null || typeof headers.forEach !== 'function') {
    return headers;
  }
  var result = {};
  headers.forEach(function (value, key) {
    if (result[key]) {
      result[key] = "".concat(result[key], ",").concat(value);
    } else {
      result[key] = "".concat(value);
    }
  });
  return result;
}

// XHR specification is unclear of what types to allow in value so using toString method for now
var stringifyHeaders = function stringifyHeaders(headers) {
  return (0, _mapValues.default)(makeObjectFromHeaders(headers), function (value) {
    return "".concat(value);
  });
};
function pluckFetchFields() {
  var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    url: arg.url,
    headers: stringifyHeaders(arg.headers),
    method: arg.method && arg.method.toUpperCase(),
    referrer: arg.referrer || undefined,
    mode: arg.mode || undefined,
    credentials: arg.credentials || undefined
  };
}
function registerFetch(_ref) {
  var addRequest = _ref.addRequest,
    addResponse = _ref.addResponse,
    isIgnored = _ref.isIgnored;
  var LOGROCKET_FETCH_LABEL = 'fetch-';
  var fetchMethodMap = {};
  var unregister = _fetchIntercept.default.register({
    request: function request(fetchId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      var p;
      if (typeof Request !== 'undefined' && args[0] instanceof Request) {
        var clonedText;

        // Request.clone() and Request.text() may throw in Safari (e.g., when
        // request body contains FormData)
        try {
          clonedText = args[0].clone().text();
        } catch (err) {
          // if a browser supports fetch, it supports promise
          // eslint-disable-next-line compat/compat
          clonedText = Promise.resolve("LogRocket fetch error: ".concat(err.message));
        }
        p = clonedText.then(function (body) {
          return _objectSpread(_objectSpread({}, pluckFetchFields(args[0])), {}, {
            body: body
          });
        }, function (err) {
          return _objectSpread(_objectSpread({}, pluckFetchFields(args[0])), {}, {
            body: "LogRocket fetch error: ".concat(err.message)
          });
        });
      } else {
        // if a browser supports fetch, it supports promise
        // eslint-disable-next-line compat/compat
        p = Promise.resolve(_objectSpread(_objectSpread({}, pluckFetchFields(args[1])), {}, {
          url: "".concat(args[0]),
          body: (args[1] || {}).body
        }));
      }
      return p.then(function (req) {
        fetchMethodMap[fetchId] = req.method;
        addRequest("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), req);
        return args;
      });
    },
    requestError: function requestError(fetchId, error) {
      // if a browser supports fetch, it supports promise
      // eslint-disable-next-line compat/compat
      return Promise.reject(error);
    },
    response: function response(fetchId, _response) {
      var responseClone;
      var responseTextPromise;
      if (isIgnored("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId))) {
        // Don't even try to read ignored requests
        return _response;
      }

      // event-streams are meant to remain open and be consumed over time by the sender. Attempting to capture the body
      // of these requests will cause us to "stall" here, and prevents the users of our SDK from using event-streams
      // unless they have explicitly ignored the request.
      if (_response.headers.get('content-type') === 'text/event-stream') {
        // eslint-disable-next-line compat/compat
        responseTextPromise = Promise.resolve('LogRocket skipped consuming an event-stream body.');
      } else {
        try {
          // TODO: enhance function on original response and future clones for:
          // text(), json(), blob(), formdata(), arraybuffer()
          responseClone = _response.clone();
        } catch (err) {
          // safari has a bug where cloning can fail
          var responseHash = {
            url: _response.url,
            responseType: _response.type.toUpperCase(),
            status: _response.status,
            headers: stringifyHeaders(_response.headers),
            body: "LogRocket fetch error: ".concat(err.message),
            method: fetchMethodMap[fetchId]
          };
          delete fetchMethodMap[fetchId];
          addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), responseHash);
          return _response;
        }
        try {
          if (window.TextDecoder && responseClone.body) {
            // use a reader to manually read the response body rather than calling response.text()
            // response.text() was timing out for some responses, in some cases because Apollo sends
            //   an abort signal or because the stream wasn't getting terminated cleanly
            // using a reader allows us to capture what we can from response bodies before the
            //   response receives an abort signal
            var reader = responseClone.body.getReader();
            // response bodies always decode with UTF-8
            // https://developer.mozilla.org/en-US/docs/Web/API/Response/text
            var utf8Decoder = new window.TextDecoder('utf-8');
            var bodyContents = '';
            responseTextPromise = reader.read().then(function readResponseBody(_ref2) {
              var done = _ref2.done,
                value = _ref2.value;
              if (done) {
                return bodyContents;
              }
              var chunk = value ? utf8Decoder.decode(value, {
                stream: true
              }) : '';
              bodyContents += chunk;
              return reader.read().then(readResponseBody);
            });
          } else {
            // TextDecoder doesn't have support across all browsers that LR supports, so if there's
            //  no TextDecoder, fall back to the old approach
            responseTextPromise = responseClone.text();
          }
        } catch (error) {
          // eslint-disable-next-line compat/compat
          responseTextPromise = Promise.resolve("LogRocket error reading body: ".concat(error.message));
        }
      }
      responseTextPromise.catch(function (error) {
        // don't drop request & log to console when the request is aborted,
        // as it may have already completed
        // https://github.com/LogRocket/logrocket/issues/34
        if (error.name === 'AbortError' && error instanceof DOMException) {
          return;
        }
        return "LogRocket error reading body: ".concat(error.message);
      }).then(function (data) {
        var responseHash = {
          url: _response.url,
          responseType: _response.type.toUpperCase(),
          status: _response.status,
          headers: stringifyHeaders(_response.headers),
          body: data,
          method: fetchMethodMap[fetchId]
        };
        delete fetchMethodMap[fetchId];
        addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), responseHash);
      });
      return _response;
    },
    responseError: function responseError(fetchId, error) {
      var response = {
        url: undefined,
        status: 0,
        headers: {},
        body: "".concat(error)
      };
      addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), response);
      // if a browser supports fetch, it supports promise
      // eslint-disable-next-line compat/compat
      return Promise.reject(error);
    }
  });
  return unregister;
}

/***/ }),

/***/ "./packages/@logrocket/network/src/registerIonic.ts":
/*!**********************************************************!*\
  !*** ./packages/@logrocket/network/src/registerIonic.ts ***!
  \**********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.mergeHeaders = mergeHeaders;
exports.serializeQueryParams = serializeQueryParams;
exports.appendQueryParamsString = appendQueryParamsString;
exports.processData = processData;
exports.registerIonic = registerIonic;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
var _typeof2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _protectFunc = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/protectFunc */ "./packages/@logrocket/utils/src/protectFunc.js"));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var VALID_HTTP_METHODS = new Set(['get', 'put', 'post', 'patch', 'head', 'delete', 'options', 'upload', 'download']);
var VALID_SERIALIZERS = new Set(['urlencoded', 'json', 'utf8']);
var UNSUPPORTED_SERIALIZERS = new Set(['raw', 'multipart']);
var LOGROCKET_IONIC_LABEL = 'ionic-';
var UNSUPPORTED_PLATFORMS = new Set(['desktop', 'mobileweb', 'pwa']);
var FORM_DATA = new Set(['FormData']);
var EMPTY_SET = new Set();
var STRING_SET = new Set(['string']);
var STRING_ARRAY_SET = new Set(['string', 'array']);
var ALLOWED_DATA_TYPES = {
  utf8: STRING_SET,
  urlencoded: new Set(['object']),
  json: new Set(['array', 'object']),
  raw: new Set(['Uint8Array', 'ArrayBuffer']),
  default: EMPTY_SET
};

// Used in intercepting Ionic pugin requests found here https://www.npmjs.com/package/@ionic-native/http
// based on https://github.com/silkimen/cordova-plugin-advanced-http/blob/master/www/public-interface.js

function checkForValidStringValue(list, value, fieldName) {
  if (typeof value !== 'string') {
    throw new Error("".concat(fieldName, " must be one of: ").concat((0, _toConsumableArray2.default)(list).join(', ')));
  }

  // eslint-disable-next-line no-param-reassign
  value = value.trim().toLowerCase();
  if (!list.has(value)) {
    throw new Error("".concat(fieldName, " must be one of: ").concat((0, _toConsumableArray2.default)(list).join(', ')));
  }
  return value;
}
function checkKeyValuePairObject(obj, allowedChildren, onInvalidValueMessage) {
  if ((0, _typeof2.default)(obj) !== 'object') {
    throw new Error(onInvalidValueMessage);
  }
  for (var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    if (!allowedChildren.has((0, _typeof2.default)(obj[key]))) {
      throw new Error(onInvalidValueMessage);
    }
  }
  return obj;
}
function getMatchingHostHeaders(url, ionicHttp) {
  var _URL = new URL(url),
    host = _URL.host;
  return ionicHttp.getHeaders(host) || null;
}
function mergeHeaders(defaultHeaders, headers) {
  return _objectSpread(_objectSpread({}, defaultHeaders), headers);
}
function getMergedHeaders(url, requestHeaders, ionicHttp) {
  // get global headers via public method
  var globalHeaders = ionicHttp.getHeaders('*') || {};
  var hostHeaders = getMatchingHostHeaders(url, ionicHttp) || {};
  return mergeHeaders(mergeHeaders(globalHeaders, hostHeaders), requestHeaders);
}
function serializeValue(value, encode) {
  if (encode) {
    return encodeURIComponent(value);
  } else {
    return value;
  }
}
function serializeIdentifier(parentKey, key, encode) {
  if (!parentKey.length) {
    return encode ? encodeURIComponent(key) : key;
  }
  if (encode) {
    return "".concat(encodeURIComponent(parentKey), "[").concat(encodeURIComponent(key), "]");
  } else {
    return "".concat(parentKey, "[").concat(key, "]");
  }
}
function serializeArray(parentKey, array, encode) {
  var parts = [];
  var _iterator = _createForOfIteratorHelper(array),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var e = _step.value;
      if (Array.isArray(e)) {
        parts.push(serializeArray("".concat(parentKey, "[]"), e, encode));
        continue;
      } else if ((0, _typeof2.default)(e) === 'object') {
        /* This replicates what appears to be a bug in the Ionic code in order to capture everything identically
           parts.push(serializeObject(`${parentKey}[]${array[i]}`, encode));
           https://github.com/silkimen/cordova-plugin-advanced-http/blob/master/www/url-util.js#L73
        */
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        parts.push(serializeObject("".concat(parentKey, "[]").concat(e), encode, undefined));
        continue;
      }
      parts.push("".concat(serializeIdentifier(parentKey, '', encode), "=").concat(serializeValue(e, encode)));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return parts.join('&');
}
function serializeObject(parentKey, object, encode) {
  var parts = [];
  for (var key in object) {
    if (!object.hasOwnProperty(key)) {
      continue;
    }
    var identifier = parentKey.length ? "".concat(parentKey, "[").concat(key, "]") : key;
    if (Array.isArray(object[key])) {
      parts.push(serializeArray(identifier, object[key], encode));
      continue;
    } else if ((0, _typeof2.default)(object[key]) === 'object' && object[key] !== null) {
      parts.push(serializeObject(identifier, object[key], encode));
      continue;
    }
    parts.push("".concat(serializeIdentifier(parentKey, key, encode), "=").concat(serializeValue(object[key], encode)));
  }
  return parts.join('&');
}
function serializeQueryParams(params, encode) {
  return serializeObject('', params, encode);
}
function appendQueryParamsString(url, params) {
  if (!url.length || !params.length) {
    return url;
  }
  var _URL2 = new URL(url),
    host = _URL2.host,
    pathname = _URL2.pathname,
    search = _URL2.search,
    hash = _URL2.hash,
    protocol = _URL2.protocol;
  return "".concat(protocol, "//").concat(host).concat(pathname).concat(search.length ? "".concat(search, "&").concat(params) : "?".concat(params)).concat(hash);
}
function getAllowedDataTypes(dataSerializer) {
  return ALLOWED_DATA_TYPES[dataSerializer] || ALLOWED_DATA_TYPES.default;
}
function getAllowedInstanceTypes(dataSerializer) {
  return dataSerializer === 'multipart' ? FORM_DATA : EMPTY_SET;
}
function processData(data, dataSerializer) {
  var currentDataType = (0, _typeof2.default)(data);
  var allowedDataTypes = getAllowedDataTypes(dataSerializer);
  var allowedInstanceTypes = getAllowedInstanceTypes(dataSerializer);
  if (allowedInstanceTypes.size > 0) {
    var isCorrectInstanceType = false;
    allowedInstanceTypes.forEach(function (type) {
      if (__webpack_require__.g[type] && data instanceof __webpack_require__.g[type]) {
        isCorrectInstanceType = true;
      }
    });
    if (!isCorrectInstanceType) {
      throw new Error("INSTANCE_TYPE_MISMATCH_DATA ".concat((0, _toConsumableArray2.default)(allowedInstanceTypes).join(', ')));
    }
  }
  if (allowedInstanceTypes.size === 0 && !allowedDataTypes.has(currentDataType)) {
    throw new Error("TYPE_MISMATCH_DATA ".concat((0, _toConsumableArray2.default)(allowedDataTypes).join(', ')));
  }
  switch (dataSerializer) {
    case 'utf8':
      // already a string
      return data;
    default:
      // object of some sort (urlencoded or json)
      return JSON.stringify(data, undefined, 2);
  }
}
function handleMissingOptions(options, ionicHttp) {
  // eslint-disable-next-line no-param-reassign
  options = options || {};
  var serializer;
  var data = options.data;
  try {
    // need to check special case if data type is not handled by LR but otherwise valid
    serializer = checkForValidStringValue(VALID_SERIALIZERS, options.serializer || ionicHttp.getDataSerializer(), 'serializer / data payload type');
  } catch (_unused) {
    // if this fails it's of entirely invalid type, let it fail
    serializer = checkForValidStringValue(UNSUPPORTED_SERIALIZERS, options.serializer || ionicHttp.getDataSerializer(), 'serializer / data payload type');
    // is of a valid but unsupported to LR type, set data to empty
    data = {};
  }
  return {
    data: data,
    filePath: options.filePath,
    followRedirect: options.followRedirect,
    headers: checkKeyValuePairObject(options.headers || {}, STRING_SET, 'Invalid header type, must be string'),
    method: checkForValidStringValue(VALID_HTTP_METHODS, options.method || VALID_HTTP_METHODS[0], 'method'),
    name: options.name,
    params: checkKeyValuePairObject(options.params || {}, STRING_ARRAY_SET, 'Invalid param, must be of type string or array'),
    responseType: options.responseType,
    serializer: serializer,
    connectTimeout: options.connectTimeout,
    readTimeout: options.readTimeout,
    timeout: options.timeout
  };
}
var ionicIdCounter = 0;
function registerIonic(_ref) {
  var _cordova, _cordova$plugin, _window$ionic;
  var addRequest = _ref.addRequest,
    addResponse = _ref.addResponse,
    isIgnored = _ref.isIgnored;
  var ionicHttp = (_cordova = window.cordova) === null || _cordova === void 0 ? void 0 : (_cordova$plugin = _cordova.plugin) === null || _cordova$plugin === void 0 ? void 0 : _cordova$plugin.http;
  var ionicMap = {};
  var unsubscribedFromIonic = false;
  if (typeof ionicHttp === 'undefined') {
    // Plugin does not exist! Empty uninstall hook.
    return function () {};
  }
  var platforms = (_window$ionic = window.ionic) === null || _window$ionic === void 0 ? void 0 : _window$ionic.platforms;
  if (typeof platforms !== 'undefined' && typeof platforms.some === 'function' && platforms.some(function (e) {
    return UNSUPPORTED_PLATFORMS.has(e);
  })) {
    // We appear to be running in a web browser, do not hook and let XHR wrap instead.
    return function () {};
  }
  var originalSendRequest = ionicHttp.sendRequest;
  var handleResponse = (0, _protectFunc.default)(function (response, isSuccess, ionicReqId) {
    if (!isIgnored("".concat(LOGROCKET_IONIC_LABEL).concat(ionicReqId))) {
      try {
        var responseHash = {
          url: response.url || '',
          status: response.status < 600 && response.status >= 100 ? response.status : 0,
          headers: response.headers || {},
          body: isSuccess ? response.data : response.error,
          method: ionicMap[ionicReqId].toUpperCase()
        };
        addResponse("".concat(LOGROCKET_IONIC_LABEL).concat(ionicReqId), responseHash);
      } catch (err) {
        var _responseHash = {
          url: response.url || '',
          status: response.status < 600 && response.status >= 100 ? response.status : 0,
          headers: response.headers || {},
          body: "LogRocket fetch error: ".concat(err.message),
          method: ionicMap[ionicReqId].toUpperCase()
        };
        addResponse("".concat(LOGROCKET_IONIC_LABEL).concat(ionicReqId), _responseHash);
      }
    } // Otherwise, don't even try to read ignored / unsubscribed requests
  });

  ionicHttp.sendRequest = function (url, options, success, failure) {
    var currentId = ++ionicIdCounter;
    var ourSuccessHandler = function ourSuccessHandler(response) {
      if (!unsubscribedFromIonic) {
        handleResponse(response, true, currentId);
        delete ionicMap[currentId];
      }
      success(response);
    };
    var ourFailureHandler = function ourFailureHandler(response) {
      if (!unsubscribedFromIonic) {
        handleResponse(response, false, currentId);
        delete ionicMap[currentId];
      }
      failure(response);
    };
    if (!unsubscribedFromIonic) {
      try {
        // will throw just like identical ionic code if input is invalid
        var modifiedOptions = handleMissingOptions(options, ionicHttp);
        var modifiedUrl = appendQueryParamsString(url, serializeObject('', modifiedOptions.params, true));
        // need to minic behavior of Ionic API by adding global headers
        var mergedHeaders = getMergedHeaders(url, modifiedOptions.headers, ionicHttp);

        // ionic APIs default to get method
        var method = modifiedOptions.method || 'get';
        ionicMap[currentId] = method;
        var requestHash = {
          url: modifiedUrl,
          method: method.toUpperCase(),
          headers: mergedHeaders || {},
          // only applicable on post, put or patch methods
          body: processData(modifiedOptions.data || {}, modifiedOptions.serializer)
        };
        addRequest("".concat(LOGROCKET_IONIC_LABEL).concat(currentId), requestHash);
      } catch (err) {
        var _requestHash = {
          url: url,
          method: (options.method || 'get').toUpperCase(),
          headers: {},
          body: "LogRocket fetch error: ".concat(err.message)
        };
        addRequest("".concat(LOGROCKET_IONIC_LABEL).concat(currentId), _requestHash);
      }
    }
    return originalSendRequest(url, options, ourSuccessHandler, ourFailureHandler);
  };
  return function () {
    unsubscribedFromIonic = true;
    ionicHttp.sendRequest = originalSendRequest;
    ionicMap = {};
  };
}

/***/ }),

/***/ "./packages/@logrocket/network/src/registerNetworkInformation.js":
/*!***********************************************************************!*\
  !*** ./packages/@logrocket/network/src/registerNetworkInformation.js ***!
  \***********************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = registerNetworkInformation;
var EFFECTIVE_TYPE_VALS = {
  'slow-2g': 'SLOW2G',
  '2g': 'TWOG',
  '3g': 'THREEG',
  '4g': 'FOURG'
};
function registerNetworkInformation(logger) {
  var lastStatus = undefined;
  function sendNetworkInformation() {
    var newStatus = {
      online: window.navigator.onLine,
      effectiveType: 'UNKOWN'
    };
    if (!window.navigator.onLine) {
      newStatus.effectiveType = 'NONE';
    } else if (window.navigator.connection && window.navigator.connection.effectiveType) {
      newStatus.effectiveType = EFFECTIVE_TYPE_VALS[window.navigator.connection.effectiveType] || 'UNKNOWN';
    }
    if (lastStatus && newStatus.online === lastStatus.online && newStatus.effectiveType === lastStatus.effectiveType) {
      return;
    }
    lastStatus = newStatus;
    logger.addEvent('lr.network.NetworkStatusEvent', function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$isEnabled = _ref.isEnabled,
        isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled;
      if (!isEnabled) {
        return null;
      }
      return newStatus;
    });
  }
  setTimeout(sendNetworkInformation);
  if (window.navigator.connection && typeof window.navigator.connection.addEventListener === 'function') {
    window.navigator.connection.addEventListener('change', sendNetworkInformation);
  }
  window.addEventListener('online', sendNetworkInformation);
  window.addEventListener('offline', sendNetworkInformation);
  return function () {
    window.removeEventListener('offline', sendNetworkInformation);
    window.removeEventListener('online', sendNetworkInformation);
    if (window.navigator.connection && typeof window.navigator.connection.removeEventListener === 'function') {
      window.navigator.connection.removeEventListener('change', sendNetworkInformation);
    }
  };
}

/***/ }),

/***/ "./packages/@logrocket/network/src/registerXHR.js":
/*!********************************************************!*\
  !*** ./packages/@logrocket/network/src/registerXHR.js ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.setActive = setActive;
exports["default"] = registerXHR;
var _mapValues = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/mapValues */ "./packages/@logrocket/utils/src/mapValues.js"));
var _enhanceFunc = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/enhanceFunc */ "./packages/@logrocket/utils/src/enhanceFunc.ts"));
var _startsWith = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/startsWith */ "./packages/@logrocket/utils/src/startsWith.js"));
var _nps = __webpack_require__(/*! @logrocket/utils/src/constants/nps */ "./packages/@logrocket/utils/src/constants/nps.js");
// eslint-disable-line no-restricted-imports
// eslint-disable-line no-restricted-imports
// eslint-disable-line no-restricted-imports

var isActive = true;
function setActive(shouldBeActive) {
  isActive = shouldBeActive;
}
var currentXHRId = 0;
function registerXHR(_ref) {
  var addRequest = _ref.addRequest,
    addResponse = _ref.addResponse,
    isIgnored = _ref.isIgnored,
    logger = _ref.logger,
    _ref$shouldAugmentNPS = _ref.shouldAugmentNPS,
    shouldAugmentNPS = _ref$shouldAugmentNPS === void 0 ? true : _ref$shouldAugmentNPS,
    _ref$shouldParseXHRBl = _ref.shouldParseXHRBlob,
    shouldParseXHRBlob = _ref$shouldParseXHRBl === void 0 ? false : _ref$shouldParseXHRBl;
  var _XHR = XMLHttpRequest;
  var xhrMap = new WeakMap();
  var unsubscribedFromXhr = false;
  var LOGROCKET_XHR_LABEL = 'xhr-';
  window._lrXMLHttpRequest = XMLHttpRequest;

  // eslint-disable-next-line no-native-reassign
  XMLHttpRequest = function XMLHttpRequest(mozAnon, mozSystem) {
    var xhrObject = new _XHR(mozAnon, mozSystem);
    if (!isActive) {
      return xhrObject;
    }
    xhrMap.set(xhrObject, {
      xhrId: ++currentXHRId,
      headers: {}
    });
    var openOriginal = xhrObject.open;
    function openShim() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      try {
        var url = args[1];
        if (window.URL && typeof window.URL === 'function' && url.search(_nps.WOOTRIC_RESPONSES_REGEX) === 0) {
          var logrocketSessionURL = new window.URL(logger.recordingURL);
          logrocketSessionURL.searchParams.set('nps', 'wootric');
          var urlObj = new window.URL(url);
          var responseText = urlObj.searchParams.get('response[text]');
          var feedback = responseText ? "".concat(responseText, "\n\n") : '';
          urlObj.searchParams.set('response[text]', "".concat(feedback, "<").concat(logrocketSessionURL.href, "|View LogRocket session>"));
          args[1] = urlObj.href; // eslint-disable-line no-param-reassign
        }
      } catch (e) {/* do nothing */}
      return openOriginal.apply(this, args);
    }
    var sendOriginal = xhrObject.send;
    function sendShim() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      try {
        var currentXHR = xhrMap.get(xhrObject);
        if (window.URL && typeof window.URL === 'function' && currentXHR && currentXHR.url && currentXHR.url.search(_nps.DELIGHTED_RESPONSES_REGEX) === 0 && args.length && args[0].indexOf(_nps.DELIGHTED_FEEDBACK_PREFIX) !== -1) {
          var recordingURL = new window.URL(logger.recordingURL);
          recordingURL.searchParams.set('nps', 'delighted');
          var logrocketSessionURL = encodeURIComponent(recordingURL.href);
          var data = args[0].split('&').map(function (dataString) {
            if ((0, _startsWith.default)(dataString, _nps.DELIGHTED_FEEDBACK_PREFIX)) {
              var isEmpty = dataString === _nps.DELIGHTED_FEEDBACK_PREFIX;
              return "".concat(dataString).concat(isEmpty ? '' : '\n\n', "<").concat(logrocketSessionURL, "|View LogRocket session>");
            }
            return dataString;
          }).join('&');
          args[0] = data; // eslint-disable-line no-param-reassign
        }
      } catch (e) {/* do nothing */}
      return sendOriginal.apply(this, args);
    }
    if (shouldAugmentNPS) {
      xhrObject.open = openShim;
      xhrObject.send = sendShim;
    }

    // ..., 'open', (method, url, async, username, password) => {
    (0, _enhanceFunc.default)(xhrObject, 'open', function (method, url) {
      if (unsubscribedFromXhr) {
        return;
      }
      var currentXHR = xhrMap.get(xhrObject);
      currentXHR.method = method;
      currentXHR.url = url;
    });
    (0, _enhanceFunc.default)(xhrObject, 'send', function (data) {
      if (unsubscribedFromXhr) {
        return;
      }
      var currentXHR = xhrMap.get(xhrObject);
      if (!currentXHR) {
        return;
      }
      var request = {
        url: currentXHR.url,
        method: currentXHR.method && currentXHR.method.toUpperCase(),
        headers: (0, _mapValues.default)(currentXHR.headers || {}, function (headerValues) {
          return headerValues.join(', ');
        }),
        body: data
      };
      addRequest("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), request);
    });
    (0, _enhanceFunc.default)(xhrObject, 'setRequestHeader', function (header, value) {
      if (unsubscribedFromXhr) {
        return;
      }
      var currentXHR = xhrMap.get(xhrObject);
      if (!currentXHR) {
        return;
      }
      currentXHR.headers = currentXHR.headers || {};
      currentXHR.headers[header] = currentXHR.headers[header] || [];
      currentXHR.headers[header].push(value);
    });
    var xhrListeners = {
      readystatechange: function readystatechange() {
        if (unsubscribedFromXhr) {
          return;
        }
        if (xhrObject.readyState === 4) {
          var currentXHR = xhrMap.get(xhrObject);
          if (!currentXHR) {
            return;
          }

          // Do not read ignored requests at all.
          if (isIgnored("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId))) {
            return;
          }
          var headerString = xhrObject.getAllResponseHeaders() || '';
          var headers = headerString.split(/[\r\n]+/).reduce(function (previous, current) {
            var next = previous;
            var headerParts = current.split(': ');
            if (headerParts.length > 0) {
              var key = headerParts.shift(); // first index of the array
              var value = headerParts.join(': '); // rest of the array repaired
              if (previous[key]) {
                next[key] += ", ".concat(value);
              } else {
                next[key] = value;
              }
            }
            return next;
          }, {});
          var body;

          // IE 11 sometimes throws when trying to access large responses
          try {
            switch (xhrObject.responseType) {
              case 'json':
                body = logger._shouldCloneResponse ? JSON.parse(JSON.stringify(xhrObject.response)) : xhrObject.response;
                break;
              case 'arraybuffer':
              case 'blob':
                {
                  body = xhrObject.response;
                  break;
                }
              case 'document':
                {
                  body = xhrObject.responseXML;
                  break;
                }
              case 'text':
              case '':
                {
                  body = xhrObject.responseText;
                  break;
                }
              default:
                {
                  body = '';
                }
            }
          } catch (err) {
            body = 'LogRocket: Error accessing response.';
          }
          var response = {
            url: currentXHR.url,
            status: xhrObject.status,
            headers: headers,
            body: body,
            method: (currentXHR.method || '').toUpperCase()
          };
          if (shouldParseXHRBlob && response.body instanceof Blob) {
            var blobReader = new FileReader();
            blobReader.readAsText(response.body);
            blobReader.onload = function () {
              try {
                response.body = JSON.parse(blobReader.result);
              } catch (_unused) {} // eslint-disable-line no-empty
              addResponse("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), response);
            };
          } else {
            addResponse("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), response);
          }
        }
      }
      // // Unused Event Listeners
      // loadstart: () => {},
      // progress: () => {},
      // abort: () => {},
      // error: () => {},
      // load: () => {},
      // timeout: () => {},
      // loadend: () => {},
    };

    Object.keys(xhrListeners).forEach(function (key) {
      xhrObject.addEventListener(key, xhrListeners[key]);
    });
    return xhrObject;
  };

  // this allows "instanceof XMLHttpRequest" to work
  XMLHttpRequest.prototype = _XHR.prototype;

  // Persist the static variables.
  ['UNSENT', 'OPENED', 'HEADERS_RECEIVED', 'LOADING', 'DONE'].forEach(function (variable) {
    XMLHttpRequest[variable] = _XHR[variable];
  });
  return function () {
    unsubscribedFromXhr = true;
    // eslint-disable-next-line no-native-reassign
    XMLHttpRequest = _XHR;
  };
}

/***/ }),

/***/ "./packages/@logrocket/now/src/index.js":
/*!**********************************************!*\
  !*** ./packages/@logrocket/now/src/index.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
/* eslint-disable compat/compat */
var dateNow = Date.now.bind(Date);
var loadTime = dateNow();
var _default = typeof performance !== 'undefined' && performance.now ? performance.now.bind(performance) : function () {
  return dateNow() - loadTime;
};
exports["default"] = _default;

/***/ }),

/***/ "./packages/@logrocket/redux/src/createEnhancer.js":
/*!*********************************************************!*\
  !*** ./packages/@logrocket/redux/src/createEnhancer.js ***!
  \*********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = createEnhancer;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
var _now = _interopRequireDefault(__webpack_require__(/*! @logrocket/now */ "./packages/@logrocket/now/src/index.js"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var storeIdCounter = 0;
function createEnhancer(logger) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$stateSanitizer = _ref.stateSanitizer,
    stateSanitizer = _ref$stateSanitizer === void 0 ? function (f) {
      return f;
    } : _ref$stateSanitizer,
    _ref$actionSanitizer = _ref.actionSanitizer,
    actionSanitizer = _ref$actionSanitizer === void 0 ? function (f) {
      return f;
    } : _ref$actionSanitizer;
  // an enhancer is a function that returns a Store
  return function (createStore) {
    return function (reducer, initialState, enhancer) {
      var store = createStore(reducer, initialState, enhancer);
      var originalDispatch = store.dispatch;
      var storeId = storeIdCounter++;
      logger.addEvent('lr.redux.InitialState', function () {
        var sanitizedState;
        try {
          // only try catch user defined functions
          sanitizedState = stateSanitizer(store.getState());
        } catch (err) {
          console.error(err.toString());
        }
        return {
          state: sanitizedState,
          storeId: storeId
        };
      });
      var dispatch = function dispatch(action) {
        var start = (0, _now.default)();
        var err;
        var res;
        try {
          res = originalDispatch(action);
        } catch (_err) {
          err = _err;
        } finally {
          var duration = (0, _now.default)() - start;
          logger.addEvent('lr.redux.ReduxAction', function () {
            var sanitizedState = null;
            var sanitizedAction = null;
            try {
              // only try catch user defined functions
              sanitizedState = stateSanitizer(store.getState());
              sanitizedAction = actionSanitizer(action);
            } catch (err) {
              console.error(err.toString());
            }
            if (sanitizedState && sanitizedAction) {
              return {
                storeId: storeId,
                action: sanitizedAction,
                duration: duration,
                stateDelta: sanitizedState
              };
            }
            return null;
          });
        }
        if (err) {
          throw err;
        }
        return res;
      };
      return _objectSpread(_objectSpread({}, store), {}, {
        dispatch: dispatch
      });
    };
  };
}

/***/ }),

/***/ "./packages/@logrocket/redux/src/createMiddleware.js":
/*!***********************************************************!*\
  !*** ./packages/@logrocket/redux/src/createMiddleware.js ***!
  \***********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = createMiddleware;
var _now = _interopRequireDefault(__webpack_require__(/*! @logrocket/now */ "./packages/@logrocket/now/src/index.js"));
var storeIdCounter = 0;
function createMiddleware(logger) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$stateSanitizer = _ref.stateSanitizer,
    stateSanitizer = _ref$stateSanitizer === void 0 ? function (f) {
      return f;
    } : _ref$stateSanitizer,
    _ref$actionSanitizer = _ref.actionSanitizer,
    actionSanitizer = _ref$actionSanitizer === void 0 ? function (f) {
      return f;
    } : _ref$actionSanitizer;
  return function (store) {
    var storeId = storeIdCounter++;
    logger.addEvent('lr.redux.InitialState', function () {
      var sanitizedState;
      try {
        // only try catch user defined functions
        sanitizedState = stateSanitizer(store.getState());
      } catch (err) {
        console.error(err.toString());
      }
      return {
        state: sanitizedState,
        storeId: storeId
      };
    });
    return function (next) {
      return function (action) {
        var start = (0, _now.default)();
        var err;
        var res;
        try {
          res = next(action);
        } catch (_err) {
          err = _err;
        } finally {
          var duration = (0, _now.default)() - start;
          logger.addEvent('lr.redux.ReduxAction', function () {
            var sanitizedState = null;
            var sanitizedAction = null;
            try {
              // only try catch user defined functions
              sanitizedState = stateSanitizer(store.getState());
              sanitizedAction = actionSanitizer(action);
            } catch (err) {
              console.error(err.toString());
            }
            if (sanitizedState && sanitizedAction) {
              return {
                storeId: storeId,
                action: sanitizedAction,
                duration: duration,
                stateDelta: sanitizedState
              };
            }
            return null;
          });
        }
        if (err) {
          throw err;
        }
        return res;
      };
    };
  };
}

/***/ }),

/***/ "./packages/@logrocket/redux/src/index.js":
/*!************************************************!*\
  !*** ./packages/@logrocket/redux/src/index.js ***!
  \************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "createEnhancer", ({
  enumerable: true,
  get: function get() {
    return _createEnhancer.default;
  }
}));
Object.defineProperty(exports, "createMiddleware", ({
  enumerable: true,
  get: function get() {
    return _createMiddleware.default;
  }
}));
var _createEnhancer = _interopRequireDefault(__webpack_require__(/*! ./createEnhancer */ "./packages/@logrocket/redux/src/createEnhancer.js"));
var _createMiddleware = _interopRequireDefault(__webpack_require__(/*! ./createMiddleware */ "./packages/@logrocket/redux/src/createMiddleware.js"));

/***/ }),

/***/ "./packages/@logrocket/utils/src/TraceKit.js":
/*!***************************************************!*\
  !*** ./packages/@logrocket/utils/src/TraceKit.js ***!
  \***************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */



/*
 TraceKit - Cross browser stack traces - github.com/occ/TraceKit

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var TraceKit = {
  collectWindowErrors: true,
  debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:Uncaught (?:exception: )?)?((?:Eval|Internal|Range|Reference|Syntax|Type|URI)Error): ?(.*)$/;
function getLocationHref() {
  if (typeof document === 'undefined' || typeof document.location === 'undefined') return '';
  return document.location.href;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = function reportModuleWrapper() {
  var handlers = [],
    lastArgs = null,
    lastException = null,
    lastExceptionStack = null;

  /**
   * Add a crash handler.
   * @param {Function} handler
   */
  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }

  /**
   * Remove a crash handler.
   * @param {Function} handler
   */
  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }

  /**
   * Remove all crash handlers.
   */
  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }

  /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */
  function notifyHandlers(stack, isWindowError) {
    var exception = null;
    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }
    if (exception) {
      throw exception;
    }
  }
  var _oldOnerrorHandler, _onErrorHandlerInstalled;

  /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} message Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */
  function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
    var stack = null;
    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
      processLastException();
    } else if (ex) {
      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(ex);
      notifyHandlers(stack, true);
    } else {
      var location = {
        'url': url,
        'line': lineNo,
        'column': colNo
      };
      var name = undefined;
      var msg = message; // must be new var or will modify original `arguments`
      var groups;
      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
          name = groups[1];
          msg = groups[2];
        }
      }
      location.func = UNKNOWN_FUNCTION;
      stack = {
        'name': name,
        'message': msg,
        'url': getLocationHref(),
        'stack': [location]
      };
      notifyHandlers(stack, true);
    }
    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }
    return false;
  }
  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }
    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }
  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }
    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }
  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
      _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }

  /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */
  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);
    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }
    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args;

    // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace
    setTimeout(function () {
      if (lastException === ex) {
        processLastException();
      }
    }, stack.incomplete ? 2000 : 0);
    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
}();

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = function computeStackTraceWrapper() {
  /**
   * Escapes special characters, except for whitespace, in a string to be
   * used inside a regular expression as a string literal.
   * @param {string} text The string.
   * @return {string} The escaped string literal.
   */
  function escapeRegExp(text) {
    return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
  }

  /**
   * Escapes special characters in a string to be used inside a regular
   * expression as a string literal. Also ensures that HTML entities will
   * be matched the same as their literal friends.
   * @param {string} body The string.
   * @return {string} The escaped string.
   */
  function escapeCodeAsRegExpForMatchingInsideHTML(body) {
    return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
  }

  // Contents of Exception in various browsers.
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;
    var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
      gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|resource|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
      winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
      lines = ex.stack.split('\n'),
      stack = [],
      parts,
      element,
      reference = /^(.*) is undefined$/.exec(ex.message);
    for (var i = 0, j = lines.length; i < j; ++i) {
      if (parts = chrome.exec(lines[i])) {
        var isNative = parts[2] && parts[2].indexOf('native') !== -1;
        element = {
          'url': !isNative ? parts[2] : null,
          'func': parts[1] || UNKNOWN_FUNCTION,
          'args': isNative ? [parts[2]] : [],
          'line': parts[3] ? +parts[3] : null,
          'column': parts[4] ? +parts[4] : null
        };
      } else if (parts = winjs.exec(lines[i])) {
        element = {
          'url': parts[2],
          'func': parts[1] || UNKNOWN_FUNCTION,
          'args': [],
          'line': +parts[3],
          'column': parts[4] ? +parts[4] : null
        };
      } else if (parts = gecko.exec(lines[i])) {
        element = {
          'url': parts[3],
          'func': parts[1] || UNKNOWN_FUNCTION,
          'args': parts[2] ? parts[2].split(',') : [],
          'line': parts[4] ? +parts[4] : null,
          'column': parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }
      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }
      stack.push(element);
    }
    if (!stack.length) {
      return null;
    }
    if (!stack[0].column && typeof ex.columnNumber !== 'undefined') {
      // FireFox uses this awesome columnNumber property for its top frame
      // Also note, Firefox's column number is 0-based and everything else expects 1-based,
      // so adding 1
      stack[0].column = ex.columnNumber + 1;
    }
    return {
      'name': ex.name,
      'message': ex.message,
      'url': getLocationHref(),
      'stack': stack
    };
  }

  /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */
  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      'url': url,
      'line': lineNo
    };
    if (initial.url && initial.line) {
      stackInfo.incomplete = false;
      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }
      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }
      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }
    return false;
  }

  /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
      stack = [],
      funcs = {},
      recursion = false,
      parts,
      item,
      source;
    for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }
      item = {
        'url': null,
        'func': UNKNOWN_FUNCTION,
        'line': null,
        'column': null
      };
      if (curr.name) {
        item.func = curr.name;
      } else if (parts = functionName.exec(curr.toString())) {
        item.func = parts[1];
      }
      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }
      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }
      stack.push(item);
    }
    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }
    var result = {
      'name': ex.name,
      'message': ex.message,
      'url': getLocationHref(),
      'stack': stack
    };
    augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
    return result;
  }

  /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */
  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;
    try {
      stack = computeStackTraceFromStackProp(ex);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    return {
      'name': ex.name,
      'message': ex.message,
      'url': getLocationHref()
    };
  }
  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
  return computeStackTrace;
}();
var _default = TraceKit;
exports["default"] = _default;

/***/ }),

/***/ "./packages/@logrocket/utils/src/constants/nps.js":
/*!********************************************************!*\
  !*** ./packages/@logrocket/utils/src/constants/nps.js ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DELIGHTED_FEEDBACK_PREFIX = exports.DELIGHTED_RESPONSES_REGEX = exports.WOOTRIC_RESPONSES_REGEX = void 0;
var WOOTRIC_RESPONSES_REGEX = /^https:\/\/production.wootric.com\/responses/;
exports.WOOTRIC_RESPONSES_REGEX = WOOTRIC_RESPONSES_REGEX;
var DELIGHTED_RESPONSES_REGEX = /^https:\/\/web.delighted.com\/e\/[a-zA-Z-]*\/c/;
exports.DELIGHTED_RESPONSES_REGEX = DELIGHTED_RESPONSES_REGEX;
var DELIGHTED_FEEDBACK_PREFIX = 'comment=';
exports.DELIGHTED_FEEDBACK_PREFIX = DELIGHTED_FEEDBACK_PREFIX;

/***/ }),

/***/ "./packages/@logrocket/utils/src/createUnsubListener.ts":
/*!**************************************************************!*\
  !*** ./packages/@logrocket/utils/src/createUnsubListener.ts ***!
  \**************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createUnsubListener = createUnsubListener;
exports.Handler = void 0;
var _classCallCheck2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js"));
var Handler = /*#__PURE__*/function () {
  function Handler(value) {
    (0, _classCallCheck2.default)(this, Handler);
    this._value = void 0;
    this._value = value;
  }
  (0, _createClass2.default)(Handler, [{
    key: "get",
    value: function get() {
      return this._value;
    }
  }, {
    key: "clear",
    value: function clear() {
      this._value = undefined;
    }
  }]);
  return Handler;
}();
/*
 * This approach ensures the unsub function never keeps a reference to the event listener's target element.
 * This is not a concern in Chrome or Firefox, but Safari will hold the entire context of a function's parent function
 * in scope of that child function. This means that creating the unsub function inside 'addListener' could cause the
 * target element (the 'obj' argument) to be held in scope of the unsub function even though it is never referenced
 * in the unsub function itself. This would lead to a memory leak after the target element is removed from the DOM.
 *
 * This function is in a separate file to prevent the Terser minifier from inline-ing the function into 'addListener'.
 */
exports.Handler = Handler;
function createUnsubListener(handler) {
  return function () {
    handler.clear();
  };
}

/***/ }),

/***/ "./packages/@logrocket/utils/src/enhanceFunc.ts":
/*!******************************************************!*\
  !*** ./packages/@logrocket/utils/src/enhanceFunc.ts ***!
  \******************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = enhanceFunc;
var _createUnsubListener = __webpack_require__(/*! ./createUnsubListener */ "./packages/@logrocket/utils/src/createUnsubListener.ts");
var NO_OP_UNREGISTER = function NO_OP_UNREGISTER() {};
function enhanceFunc(obj, method, handler) {
  if (typeof obj[method] !== 'function') {
    return NO_OP_UNREGISTER;
  }
  try {
    // eslint-disable-next-line no-inner-declarations
    var shim = function shim() {
      var _h$get;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var res = original.apply(this, args);
      (_h$get = h.get()) === null || _h$get === void 0 ? void 0 : _h$get.apply(this, args);
      return res;
    }; // eslint-disable-next-line no-param-reassign
    var original = obj[method];
    var h = new _createUnsubListener.Handler(handler);
    obj[method] = shim;
    return function () {
      // Disable our shim from running, and if the method hasn't been re-shimmed
      // since our shim was applied, safely reset the method to its prior state
      h.clear();
      if (obj[method] === shim) {
        // eslint-disable-next-line no-param-reassign
        obj[method] = original;
      }
    };
  } catch (_error) {
    return NO_OP_UNREGISTER;
  }
}

/***/ }),

/***/ "./packages/@logrocket/utils/src/logError.js":
/*!***************************************************!*\
  !*** ./packages/@logrocket/utils/src/logError.js ***!
  \***************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var canBind = typeof console !== 'undefined' && console.error && console.error.bind;
var logError = canBind ? console.error.bind(console) : function () {};
var _default = logError;
exports["default"] = _default;

/***/ }),

/***/ "./packages/@logrocket/utils/src/mapValues.js":
/*!****************************************************!*\
  !*** ./packages/@logrocket/utils/src/mapValues.js ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = mapValues;
function mapValues(obj, f) {
  if (obj == null) {
    return {};
  }
  var res = {};
  Object.keys(obj).forEach(function (key) {
    res[key] = f(obj[key]);
  });
  return res;
}

/***/ }),

/***/ "./packages/@logrocket/utils/src/protectFunc.js":
/*!******************************************************!*\
  !*** ./packages/@logrocket/utils/src/protectFunc.js ***!
  \******************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = protectFunc;
var _sendTelemetryData = _interopRequireDefault(__webpack_require__(/*! ./sendTelemetryData */ "./packages/@logrocket/utils/src/sendTelemetryData.js"));
var _logError = _interopRequireDefault(__webpack_require__(/*! ./logError */ "./packages/@logrocket/utils/src/logError.js"));
function protectFunc(f) {
  var onFail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  return function () {
    var result;
    try {
      result = f.apply(void 0, arguments);
    } catch (err) {
      if (typeof window !== 'undefined' && window._lrdebug) {
        throw err;
      }
      var payload = onFail(err);
      (0, _logError.default)('LogRocket', err);
      (0, _sendTelemetryData.default)(err, payload);
    }
    return result;
  };
}

/***/ }),

/***/ "./packages/@logrocket/utils/src/scrubException.ts":
/*!*********************************************************!*\
  !*** ./packages/@logrocket/utils/src/scrubException.ts ***!
  \*********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.scrubException = scrubException;
var _typeof2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function isScalar(value) {
  return /boolean|number|string/.test((0, _typeof2.default)(value));
}
var optionalScalars = [
// Valid values for 'level' are 'fatal', 'error', 'warning', 'info',
// and 'debug'. Defaults to 'error'.
'level', 'logger'];
var optionalMaps = ['tags', 'extra'];
function scrubException(data, options) {
  if (options) {
    var _iterator = _createForOfIteratorHelper(optionalScalars),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var field = _step.value;
        var value = options[field];
        if (isScalar(value)) {
          // eslint-disable-next-line no-param-reassign
          data[field] = value.toString();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var _iterator2 = _createForOfIteratorHelper(optionalMaps),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _field = _step2.value;
        var dirty = options[_field] || {};
        var scrubbed = {};
        for (var _i = 0, _Object$keys = Object.keys(dirty); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];
          var _value = dirty[key];
          if (isScalar(_value)) {
            scrubbed[key.toString()] = _value.toString();
          }
        }

        // eslint-disable-next-line no-param-reassign
        data[_field] = scrubbed;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
}

/***/ }),

/***/ "./packages/@logrocket/utils/src/sendTelemetryData.js":
/*!************************************************************!*\
  !*** ./packages/@logrocket/utils/src/sendTelemetryData.js ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.sendTelemetry = sendTelemetry;
exports["default"] = sendErrorTelemetry;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
var _logError = _interopRequireDefault(__webpack_require__(/*! ./logError */ "./packages/@logrocket/utils/src/logError.js"));
var _TraceKit = _interopRequireDefault(__webpack_require__(/*! ./TraceKit */ "./packages/@logrocket/utils/src/TraceKit.js"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// eslint-disable-next-line no-undef
var SCRIPT_VERSION =  true ? "13dd130ab9a04ef867cdb9bbbdb0a16c225358f2" : 0;
function _sendToSentry(data) {
  var XHR = window._lrXMLHttpRequest || XMLHttpRequest;
  try {
    var _window, _window$__SDKCONFIG__;
    var req = new XHR();
    var message = data.message;
    var url = 'https://e.logrocket.com/api/3/store/?sentry_version=7&sentry_client=http%2F3.8.0&sentry_key=b64162b4187a4c5caae8a68a7e291793';
    req.open('POST', url);
    req.send(JSON.stringify(_objectSpread({
      message: message,
      logger: 'javascript',
      platform: 'javascript',
      request: {
        headers: {
          'User-Agent': typeof navigator !== 'undefined' && navigator.userAgent
        },
        url: typeof location !== 'undefined' && location.href
      },
      release: SCRIPT_VERSION,
      environment: ((_window = window) === null || _window === void 0 ? void 0 : (_window$__SDKCONFIG__ = _window.__SDKCONFIG__) === null || _window$__SDKCONFIG__ === void 0 ? void 0 : _window$__SDKCONFIG__.scriptEnv) || 'prod'
    }, data)));
  } catch (err) {
    (0, _logError.default)('Failed to send', err);
  }
}
function sendTelemetry(message, more) {
  if (typeof window !== 'undefined' && window._lrdebug) {
    return void (0, _logError.default)(message);
  }
  if (more && more.extra && more.extra.appID && typeof more.extra.appID.indexOf === 'function' && more.extra.appID.indexOf('au2drp/') === 0 && Math.random() >= 0.25) {
    return;
  }
  _sendToSentry(_objectSpread({
    message: message
  }, more));
}
function sendErrorTelemetry(err, payload) {
  try {
    var message = err.message;
    var stringPayload;
    try {
      stringPayload = JSON.stringify(payload).slice(0, 1000);
    } catch (err) {
      try {
        stringPayload = "Could not stringify payload: ".concat(Object.prototype.toString.call(payload));
      } catch (err) {/* nada */}
    }
    var stack;
    try {
      stack = _TraceKit.default.computeStackTrace(err).stack.map(function (frame) {
        return {
          filename: frame.url,
          lineno: frame.line,
          colno: frame.column,
          function: frame.func || '?'
        };
      });
    } catch (err) {
      /* nada */
    }
    _sendToSentry({
      message: message,
      extra: {
        stringPayload: stringPayload
      },
      exception: {
        values: [{
          type: err.type,
          value: message,
          stacktrace: {
            frames: stack
          }
        }]
      }
    });
  } catch (err) {
    (0, _logError.default)('Failed to send', err);
  }
}

/***/ }),

/***/ "./packages/@logrocket/utils/src/startsWith.js":
/*!*****************************************************!*\
  !*** ./packages/@logrocket/utils/src/startsWith.js ***!
  \*****************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startsWith;
function startsWith(value, search) {
  var pos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return value && search && value.substring(pos, pos + search.length) === search;
}

/***/ }),

/***/ "./packages/logrocket/src/LogRocket.js":
/*!*********************************************!*\
  !*** ./packages/logrocket/src/LogRocket.js ***!
  \*********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.MAX_QUEUE_SIZE = void 0;
var _classCallCheck2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js"));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js"));
var _network = _interopRequireDefault(__webpack_require__(/*! @logrocket/network */ "./packages/@logrocket/network/src/index.js"));
var _exceptions = __webpack_require__(/*! @logrocket/exceptions */ "./packages/@logrocket/exceptions/src/index.js");
var _console = _interopRequireDefault(__webpack_require__(/*! @logrocket/console */ "./packages/@logrocket/console/src/index.js"));
var _redux = __webpack_require__(/*! @logrocket/redux */ "./packages/@logrocket/redux/src/index.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var MAX_QUEUE_SIZE = 1000;
exports.MAX_QUEUE_SIZE = MAX_QUEUE_SIZE;
var considerIngestServerOption = function considerIngestServerOption() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    ingestServer = _ref.ingestServer,
    options = (0, _objectWithoutProperties2.default)(_ref, ["ingestServer"]);
  if (ingestServer) {
    return _objectSpread({
      serverURL: "".concat(ingestServer, "/i"),
      statsURL: "".concat(ingestServer, "/s")
    }, options);
  }
  return options;
};
var LogRocket = /*#__PURE__*/function () {
  function LogRocket() {
    var _this = this;
    (0, _classCallCheck2.default)(this, LogRocket);
    this._buffer = [];
    // TODO: tests for these exposed methods.
    ['log', 'info', 'warn', 'error', 'debug'].forEach(function (method) {
      _this[method] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this.addEvent('lr.core.LogEvent', function () {
          var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (method === 'error' && consoleOptions.shouldAggregateConsoleErrors) {
            _exceptions.Capture.captureMessage(_this, args[0], args, {}, true);
          }
          return {
            logLevel: method.toUpperCase(),
            args: args
          };
        }, {
          shouldCaptureStackTrace: true
        });
      };
    });
    this._isInitialized = false;
    this._installed = [];

    // expose a callback to get the session URL from the global context
    window._lr_surl_cb = this.getSessionURL.bind(this);
  }
  (0, _createClass2.default)(LogRocket, [{
    key: "addEvent",
    value: function addEvent(type, getMessage) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var time = Date.now();
      this._run(function (logger) {
        logger.addEvent(type, getMessage, _objectSpread(_objectSpread({}, opts), {}, {
          timeOverride: time
        }));
      });
    }
  }, {
    key: "onLogger",
    value: function onLogger(logger) {
      this._logger = logger;
      while (this._buffer.length > 0) {
        var f = this._buffer.shift();
        f(this._logger);
      }
    }
  }, {
    key: "_run",
    value: function _run(f) {
      if (this._isDisabled) {
        return;
      }
      if (this._logger) {
        f(this._logger);
      } else {
        if (this._buffer.length >= MAX_QUEUE_SIZE) {
          this._isDisabled = true;
          console.warn('LogRocket: script did not load. Check that you have a valid network connection.');
          this.uninstall();
          return;
        }
        this._buffer.push(f.bind(this));
      }
    }
  }, {
    key: "init",
    value: function init(appID) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this._isInitialized) {
        var _opts$network;
        var _opts$shouldAugmentNP = opts.shouldAugmentNPS,
          shouldAugmentNPS = _opts$shouldAugmentNP === void 0 ? true : _opts$shouldAugmentNP,
          _opts$shouldParseXHRB = opts.shouldParseXHRBlob,
          shouldParseXHRBlob = _opts$shouldParseXHRB === void 0 ? false : _opts$shouldParseXHRB,
          _opts$shouldDetectExc = opts.shouldDetectExceptions,
          shouldDetectExceptions = _opts$shouldDetectExc === void 0 ? true : _opts$shouldDetectExc;
        if (shouldDetectExceptions) {
          this._installed.push((0, _exceptions.registerExceptions)(this));
        }
        this._installed.push((0, _network.default)(this, {
          shouldAugmentNPS: !!shouldAugmentNPS,
          shouldParseXHRBlob: !!shouldParseXHRBlob,
          isDisabled: (opts === null || opts === void 0 ? void 0 : (_opts$network = opts.network) === null || _opts$network === void 0 ? void 0 : _opts$network.isEnabled) === false
        }));
        this._installed.push((0, _console.default)(this));
        this._isInitialized = true;
        this._run(function (logger) {
          logger.init(appID, considerIngestServerOption(opts));
        });
      }
    }
  }, {
    key: "start",
    value: function start() {
      this._run(function (logger) {
        logger.start();
      });
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this._installed.forEach(function (f) {
        return f();
      });
      this._buffer = [];
      this._run(function (logger) {
        logger.uninstall();
      });
    }
  }, {
    key: "identify",
    value: function identify(id, opts) {
      this._run(function (logger) {
        logger.identify(id, opts);
      });
    }
  }, {
    key: "startNewSession",
    value: function startNewSession() {
      this._run(function (logger) {
        logger.startNewSession();
      });
    }
  }, {
    key: "track",
    value: function track(customEventName, eventProperties) {
      this._run(function (logger) {
        logger.track(customEventName, eventProperties);
      });
    }
  }, {
    key: "getSessionURL",
    value: function getSessionURL(cb) {
      if (typeof cb !== 'function') {
        throw new Error('LogRocket: must pass callback to getSessionURL()');
      }
      this._run(function (logger) {
        if (logger.getSessionURL) {
          logger.getSessionURL(cb);
        } else {
          cb(logger.recordingURL);
        }
      });
    }
  }, {
    key: "trackScrollEvent",
    value: function trackScrollEvent(target) {
      // Only reigster the event if the core logger is available,
      //  otherwise we won't yet have captured the target element:
      if (this._logger) {
        this._logger.trackScrollEvent(target);
      }
    }
  }, {
    key: "getVersion",
    value: function getVersion(cb) {
      this._run(function (logger) {
        cb(logger.version);
      });
    }
  }, {
    key: "captureMessage",
    value: function captureMessage(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _exceptions.Capture.captureMessage(this, message, [message], options);
    }
  }, {
    key: "captureException",
    value: function captureException(exception) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _exceptions.Capture.captureException(this, exception, options);
    }
  }, {
    key: "version",
    get: function get() {
      return this._logger && this._logger.version;
    }
  }, {
    key: "sessionURL",
    get: function get() {
      return this._logger && this._logger.recordingURL;
    }
  }, {
    key: "recordingURL",
    get: function get() {
      return this._logger && this._logger.recordingURL;
    }
  }, {
    key: "recordingID",
    get: function get() {
      return this._logger && this._logger.recordingID;
    }
  }, {
    key: "threadID",
    get: function get() {
      return this._logger && this._logger.threadID;
    }
  }, {
    key: "tabID",
    get: function get() {
      return this._logger && this._logger.tabID;
    }
  }, {
    key: "reduxEnhancer",
    value: function reduxEnhancer() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _redux.createEnhancer)(this, options);
    }
  }, {
    key: "reduxMiddleware",
    value: function reduxMiddleware() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _redux.createMiddleware)(this, options);
    }
  }, {
    key: "isDisabled",
    get: function get() {
      return !!(this._isDisabled || this._logger && this._logger._isDisabled);
    }
  }]);
  return LogRocket;
}();
exports["default"] = LogRocket;

/***/ }),

/***/ "./packages/logrocket/src/makeLogRocket.js":
/*!*************************************************!*\
  !*** ./packages/logrocket/src/makeLogRocket.js ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = makeLogRocket;
var _LogRocket = _interopRequireDefault(__webpack_require__(/*! ./LogRocket */ "./packages/logrocket/src/LogRocket.js"));
var REACT_NATIVE_NOTICE = 'LogRocket on React Native requires the LogRocket React Native specific SDK. See setup guide here https://docs.logrocket.com/reference/react-native.';
var makeNoopPolyfill = function makeNoopPolyfill() {
  return {
    init: function init() {},
    uninstall: function uninstall() {},
    log: function log() {},
    info: function info() {},
    warn: function warn() {},
    error: function error() {},
    debug: function debug() {},
    addEvent: function addEvent() {},
    identify: function identify() {},
    start: function start() {},
    get threadID() {
      return null;
    },
    get recordingID() {
      return null;
    },
    get recordingURL() {
      return null;
    },
    reduxEnhancer: function reduxEnhancer() {
      return function (store) {
        return function () {
          return store.apply(void 0, arguments);
        };
      };
    },
    reduxMiddleware: function reduxMiddleware() {
      return function () {
        return function (next) {
          return function (action) {
            return next(action);
          };
        };
      };
    },
    track: function track() {},
    getSessionURL: function getSessionURL() {},
    getVersion: function getVersion() {},
    startNewSession: function startNewSession() {},
    onLogger: function onLogger() {},
    setClock: function setClock() {},
    captureMessage: function captureMessage() {},
    captureException: function captureException() {}
  };
};
function makeLogRocket() {
  var getLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var getNoopPolyfill = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : makeNoopPolyfill;
  var getInstance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return new _LogRocket.default();
  };
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    throw new Error(REACT_NATIVE_NOTICE);
  }
  if (typeof window !== 'undefined') {
    if (window._disableLogRocket) {
      return getNoopPolyfill();
    }
    if (window.MutationObserver && window.WeakMap) {
      // Save window globals that we rely on.
      window._lrMutationObserver = window.MutationObserver;
      var instance = getInstance();
      getLogger(instance);
      return instance;
    }
  }
  return makeNoopPolyfill();
}

/***/ }),

/***/ "./packages/logrocket/src/setup.js":
/*!*****************************************!*\
  !*** ./packages/logrocket/src/setup.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainsAndEnv = getDomainsAndEnv;
exports.setupBaseSDKCONFIG = setupBaseSDKCONFIG;
exports["default"] = setup;
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js"));
var _makeLogRocket = _interopRequireDefault(__webpack_require__(/*! ./makeLogRocket */ "./packages/logrocket/src/makeLogRocket.js"));
var CDN_SERVER_MAP = {
  'cdn.logrocket.com': 'https://r.logrocket.io',
  'cdn.logrocket.io': 'https://r.logrocket.io',
  'cdn.lr-ingest.io': 'https://r.lr-ingest.io',
  'cdn.lr-in.com': 'https://r.lr-in.com',
  'cdn.lr-in-prod.com': 'https://r.lr-in-prod.com',
  'cdn.lr-ingest.com': 'https://r.lr-ingest.com',
  'cdn.ingest-lr.com': 'https://r.ingest-lr.com',
  'cdn.lr-intake.com': 'https://r.lr-intake.com',
  'cdn.intake-lr.com': 'https://r.intake-lr.com',
  'cdn.logr-ingest.com': 'https://r.logr-ingest.com',
  'cdn.lrkt-in.com': 'https://r.lrkt-in.com',
  'cdn-staging.logrocket.io': 'https://staging-i.logrocket.io',
  'cdn-staging.lr-ingest.io': 'https://staging-i.lr-ingest.io',
  'cdn-staging.lr-in.com': 'https://staging-i.lr-in.com',
  'cdn-staging.lr-in-prod.com': 'https://staging-i.lr-in-prod.com',
  'cdn-staging.lr-ingest.com': 'https://staging-i.lr-ingest.com',
  'cdn-staging.ingest-lr.com': 'https://staging-i.ingest-lr.com',
  'cdn-staging.lr-intake.com': 'https://staging-i.lr-intake.com',
  'cdn-staging.intake-lr.com': 'https://staging-i.intake-lr.com',
  'cdn-staging.logr-ingest.com': 'https://staging-i.logr-ingest.com',
  'cdn-staging.lrkt-in.com': 'https://staging-i.lrkt-in.com'
};
function envFromHostname(hostname) {
  if (hostname.startsWith('cdn-staging')) {
    return 'staging';
  } else if (hostname.startsWith('localhost')) {
    return 'development';
  } else {
    return 'prod';
  }
}
function getDomainsAndEnv(sdkVersion) {
  if (sdkVersion === 'script' || sdkVersion === 'shopify-pixel') {
    // We cannot rely on the DEPLOY_ENV config for script tag usage: we deploy the script built for staging to prod to
    // improve deployment times, so the DEPLOY_ENV is always 'staging' for script usage! Instead we default to 'prod'
    // and inspect the script's URL to determine if the environment should instead be staging or development.
    try {
      // eslint-disable-next-line compat/compat
      var scriptTag = document.currentScript;
      var matches = scriptTag.src.match(/^(https?:\/\/([^\\]+))\/.+$/);
      var scriptHostname = matches && matches[2];
      if (scriptHostname && CDN_SERVER_MAP[scriptHostname]) {
        return {
          scriptEnv: envFromHostname(scriptHostname),
          scriptOrigin: matches && matches[1],
          scriptIngest: CDN_SERVER_MAP[scriptHostname]
        };
      }
    } catch (_) {
      /* no-op */
    }

    // If we cannot determine the env based on the script's URL we default to prod.
    return {
      scriptEnv: 'prod',
      scriptOrigin: 'https://cdn.logrocket.io'
    };
  } else {
    // NPM package
    return {
      scriptEnv: undefined,
      scriptOrigin:  false ? 0 : 'https://cdn.lrkt-in.com',
      scriptIngest:  false ? 0 : 'https://r.lrkt-in.com'
    };
  }
}
function setupBaseSDKCONFIG(ingestServer) {
  if (typeof window.__SDKCONFIG__ === 'undefined') {
    window.__SDKCONFIG__ = {};
  }
  window.__SDKCONFIG__.serverURL = "".concat(ingestServer, "/i");
  window.__SDKCONFIG__.statsURL = "".concat(ingestServer, "/s");
}
function setup() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    enterpriseServer = _ref.enterpriseServer,
    _ref$sdkVersion = _ref.sdkVersion,
    sdkVersion = _ref$sdkVersion === void 0 ? "9.0.2" : _ref$sdkVersion,
    opts = (0, _objectWithoutProperties2.default)(_ref, ["enterpriseServer", "sdkVersion"]);
  var _getDomainsAndEnv = getDomainsAndEnv(sdkVersion),
    scriptEnv = _getDomainsAndEnv.scriptEnv,
    scriptOrigin = _getDomainsAndEnv.scriptOrigin,
    scriptIngest = _getDomainsAndEnv.scriptIngest;
  var sdkServer = opts.sdkServer || enterpriseServer;
  var ingestServer = opts.ingestServer || enterpriseServer || scriptIngest;
  var instance = (0, _makeLogRocket.default)(function () {
    var script = document.createElement('script');
    if (ingestServer) {
      setupBaseSDKCONFIG(ingestServer);
      window.__SDKCONFIG__.scriptEnv = scriptEnv;
    }
    if (sdkServer) {
      script.src = "".concat(sdkServer, "/logger.min.js");
    } else if (window.__SDKCONFIG__ && window.__SDKCONFIG__.loggerURL) {
      script.src = window.__SDKCONFIG__.loggerURL;
    } else if (window._lrAsyncScript) {
      script.src = window._lrAsyncScript;
    } else {
      script.src = "".concat(scriptOrigin, "/logger-1.min.js");
    }
    script.async = true;
    document.head.appendChild(script);
    script.onload = function () {
      // Brave browser: Advertises its user-agent as Chrome ##.##... then
      // loads logger.min.js, but blocks the execution of the script
      // causing _LRlogger to be undefined.  Let's make sure its there first.
      if (typeof window._LRLogger === 'function') {
        setTimeout(function () {
          instance.onLogger(new window._LRLogger({
            sdkVersion: sdkVersion
          }));
        });
      } else {
        console.warn('LogRocket: script execution has been blocked by a product or service.');
        instance.uninstall();
      }
    };
    script.onerror = function () {
      console.warn('LogRocket: script could not load. Check that you have a valid network connection.');
      instance.uninstall();
    };
  });
  return instance;
}

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayLikeToArray.js ***!
  \*****************************************************************/
/***/ (function(module) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/classCallCheck.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/classCallCheck.js ***!
  \***************************************************************/
/***/ (function(module) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/createClass.js":
/*!************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/createClass.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(/*! ./toPropertyKey.js */ "./node_modules/@babel/runtime/helpers/toPropertyKey.js");
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/defineProperty.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/defineProperty.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(/*! ./toPropertyKey.js */ "./node_modules/@babel/runtime/helpers/toPropertyKey.js");
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/interopRequireDefault.js ***!
  \**********************************************************************/
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/iterableToArray.js":
/*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/iterableToArray.js ***!
  \****************************************************************/
/***/ (function(module) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/nonIterableSpread.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/nonIterableSpread.js ***!
  \******************************************************************/
/***/ (function(module) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js":
/*!************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/objectWithoutProperties.js ***!
  \************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(/*! ./objectWithoutPropertiesLoose.js */ "./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js");
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js ***!
  \*****************************************************************************/
/***/ (function(module) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/toConsumableArray.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toConsumableArray.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(/*! ./arrayWithoutHoles.js */ "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js");
var iterableToArray = __webpack_require__(/*! ./iterableToArray.js */ "./node_modules/@babel/runtime/helpers/iterableToArray.js");
var unsupportedIterableToArray = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js");
var nonIterableSpread = __webpack_require__(/*! ./nonIterableSpread.js */ "./node_modules/@babel/runtime/helpers/nonIterableSpread.js");
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/toPrimitive.js":
/*!************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toPrimitive.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"]);
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/toPropertyKey.js":
/*!**************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toPropertyKey.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"]);
var toPrimitive = __webpack_require__(/*! ./toPrimitive.js */ "./node_modules/@babel/runtime/helpers/toPrimitive.js");
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/typeof.js":
/*!*******************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/typeof.js ***!
  \*******************************************************/
/***/ (function(module) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js ***!
  \***************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
var exports = __webpack_exports__;
/*!**********************************************!*\
  !*** ./packages/logrocket/src/module-npm.js ***!
  \**********************************************/


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _setup = _interopRequireDefault(__webpack_require__(/*! ./setup */ "./packages/logrocket/src/setup.js"));
var instance = (0, _setup.default)();
var _default = instance;
exports["default"] = _default;
}();
__webpack_exports__ = __webpack_exports__["default"];
/******/ 	return __webpack_exports__;
/******/ })()
;
});


//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/logrocket/dist/build.umd.js
// module id = wo9E
// module chunks = 3